'use strict';
const angular = require('angular');

export class feedbackFormComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit = function () {
    //this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.feedback});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduApp.feedbackForm', [])
  .component('feedbackForm', {
    template: require('./feedback-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: feedbackFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/feedback-form/feedback-form.component.js